import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  FormsModule as AngularFormsModule,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { ChartsModule } from "ng2-charts";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { QrCodeModule } from "../batchstamp/qr-code/qr-code.module";
import { ImageService } from "../../../imageService";
import { GiftComponent } from "./gift.component";
import {
  ConfirmDialogModule,
  GrowlModule,
  TooltipModule
} from "primeng/primeng";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFormsModule,
    ChartsModule,
    BsDatepickerModule.forRoot(),
    QrCodeModule,
    ConfirmDialogModule
  ],
  declarations: [GiftComponent],
  providers: [ImageService]
})
export class GiftModule {}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/gift/gift.module.ts